export const applyCouponMixin = {
  data() {
    return {
      couponString: '',
      loading: false,
      error: false,
      success: false,
    };
  },

  computed: {
    canApply() {
      return this.couponString.length > 2;
    },
  },

  methods: {
    async apply() {
      if (!this.canApply) {
        return;
      }

      this.loading = true;
      this.error = false;
      this.success = false;

      // Check the validity of the coupon
      await fetch(`/api/coupon/${this.couponString}`)
        .then(res => res.json())
        .then(({ ok, coupon }) => {
          if (!ok) {
            throw new Error();
          }

          // Apply the coupon on the cart
          this.$store.dispatch('cart/applyCoupon', coupon.code);
          this.success = true;
        })
        .catch(err => {
          this.error = true;
        });

      // Reset the input
      this.couponString = '';
      this.loading = false;
    },
  },
};
